import { Order, OrderItem } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { SoftDeleteEntityRepository } from './generic'

@Injectable()
export class OrderRepository extends SoftDeleteEntityRepository<Order> {
	constructor(@InjectRepository(Order) override readonly _repository: Repository<Order>) {
		super(_repository)
	}
}

@Injectable()
export class OrderItemRepository extends SoftDeleteEntityRepository<OrderItem> {
	constructor(@InjectRepository(OrderItem) override readonly _repository: Repository<OrderItem>) {
		super(_repository)
	}
}
